import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getOfficeStatsMonth, getOfficeStatsYear, switchOfficeStats, officeStatsReset } from './actions';
import { STATS_SHOW_DATE_SWITCH } from '../../config';
import TitleTop from '../../common/TitleTop/TitleTop';
import StatsSwitcher from './StatsSwitcher';
import Charts from './Charts';

import { StyledOfficeStats } from './styles/StyledOfficeStats';


class OfficeStats extends Component {
  constructor(props) {
    super(props);

    this.switchStats = this.switchStats.bind(this);
    this.switchDate = this.switchDate.bind(this);
  }

  componentDidMount() {
    const { officeId, serviceId, dateChecked, } = this.props;
    this.props.officeStatsReset();

    const dateFormat = new Date()
    const month = dateFormat.getMonth();
    const year = dateFormat.getFullYear();

    if (dateChecked === 'month') {
      this.props.getOfficeStatsMonth(officeId, serviceId, year, month);
    }
    else {
      this.props.getOfficeStatsYear(officeId, serviceId, year, month);
    }
  }

  switchStats() {
    this.props.switchOfficeStats(
      this.props.statsChecked === 'waitingTime' ? 'servedClients' : 'waitingTime',
      this.props.dateChecked
    );
  }

  switchDate() {
    const newDataChecked = this.props.dateChecked === 'year' ? 'month' : 'year';

    this.props.switchOfficeStats(
      this.props.statsChecked,
      newDataChecked
    );

    const { statsYear, statsMonth, officeId, serviceId, year, month, } = this.props;

    if (newDataChecked === 'year' && !statsYear.catchedData) {
      this.props.getOfficeStatsYear(officeId, serviceId, year, month);
    }
    else if (newDataChecked === 'month' && !statsMonth.catchedData) {
      this.props.getOfficeStatsMonth(officeId, serviceId, year, month);
    }
  }

  render() {
    const { statsChecked, dateChecked, statsYear, statsMonth, selected, year, month,} = this.props;

    return (
      <StyledOfficeStats>
        
        <TitleTop
          title={'Statistiky služby'}
        />

        <StatsSwitcher
          showDateSwitch={STATS_SHOW_DATE_SWITCH}
          statsSwitch={this.switchStats}
          dateSwitch={this.switchDate}
          statsCheck={statsChecked === 'waitingTime' ? false : true}
          dateChecked={dateChecked === 'year' ? false : true}
        />

        <Charts
          year={year}
          month={month}
          dateChecked={dateChecked}
          statsData={dateChecked === 'year' ? statsYear : statsMonth}
          statsType={statsChecked === 'servedClients' ? 'clients_sum' : 'avg_time'}
          maxValue={statsChecked === 'servedClients' ? 'maxCliSum' : 'maxAvgTime'}
          selected={selected}
        />

      </StyledOfficeStats>
    );
  }
}


OfficeStats.propTypes = {
  officeId: PropTypes.string.isRequired,
  serviceId: PropTypes.string.isRequired,
};


const mapStateToProps = (state) => {
  const { statsChecked, dateChecked, statsYear, statsMonth, year, month, selected, } = state.officeStats;

  return { statsChecked, dateChecked, statsYear, statsMonth, year, month, selected, };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getOfficeStatsMonth: bindActionCreators(getOfficeStatsMonth, dispatch),
    getOfficeStatsYear: bindActionCreators(getOfficeStatsYear, dispatch),
    switchOfficeStats: bindActionCreators(switchOfficeStats, dispatch),
    officeStatsReset: bindActionCreators(officeStatsReset, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficeStats);
